//MainInvestigatingAssets
import React, { useEffect, useState } from "react";
import { Collapse, Button, Row, Pagination, Col, Select, notification, Table, Spin, Divider } from "antd";
import ModalsAddAssets from "../modals/ModalsAddAssets";
import { CaretRightOutlined } from '@ant-design/icons';
import { mockContracts } from "./MockData";
import axios from "axios";
import MotionHoc from "../../../../utils/MotionHoc";
import { POST_LOAD_MAIN_ASSET } from "../../../API/apiUrls";
import dayjs from "dayjs";

const { Panel } = Collapse;
const { Option } = Select;

function MainInvestigatingAssets() {
    const [api, contextHolder] = notification.useNotification();
    const [modalVisible, setModalVisible] = useState(false);
    const [guarantors, setGuarantors] = useState([]);
    const [datas, setdatas] = useState({});
    const [dataInvestigation, setDataInvestigation] = useState([]); // ข้อมูลที่ดึงมาจากฐษนข้อมูล
    const [loading, setLoading] = useState(false)

    // select Province
    const [dataAllProvince, setDataAllProvince] = useState([]);
    const [filterProvince, setFilterProvince] = useState(null); // จังหวัด
    const [optionProvince, setOptionProvince] = useState([]); // จังหวัด
    const [filterDistrict, setFilterDistrict] = useState(null); // อำเภอ
    const [filterContractId, setFilterContractId] = useState(""); // เลขสัญญา
    const [searchData, setSearchData] = useState([]); // ค้นหาข้อมูลสัญญาที่ตรงกับเงื่อนไข

    // pagition
    const [page, setPage] = useState(1);
    const pageSize = 10;

    const paginatedContracts = searchData?.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    useEffect(() => {
        loadDataInvestigation();
    }, [])

    // console.log("dataInvestigation", dataInvestigation);
    // console.log("optionProvince", optionProvince);
    // console.log("filterProvince", filterProvince);
    // console.log("filterDistrict", filterDistrict);
    // console.log("dataAllProvince", dataAllProvince);
    // console.log("searchData", searchData);
    // console.log("paginatedContracts", paginatedContracts);

    const openModal = (contract) => {
        setGuarantors(contract?.customerList || []);
        setdatas(contract);
        setModalVisible(true);
    };

    const loadDataInvestigation = async () => {
        const USERID = 888
        const params = {
            province: "",
            district: "",
            contno: "",
            userId: USERID
        }
        try {
            setLoading(true)
            const response = await axios.post(
                POST_LOAD_MAIN_ASSET,
                params,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                    },
                }

            );
            console.log("response loadDataInvestigation", response?.data);
            if (response?.data) {
                setDataAllProvince(response?.data)
                const provinces = [
                    ...new Set(response?.data.map(item => item.provinceName))
                ];
                console.log("provinces", provinces);
                setOptionProvince(provinces)
                setDataInvestigation(response?.data)
                setSearchData(response?.data)
                setLoading(false)
            } else {
                api.error({
                    message: 'โหลดข้อมูลไม่สำเร็จ',
                    placement: 'top',
                });
                setLoading(false)
            }

        } catch {
            console.error("❌ API Error:");
            api.error({
                message: 'เกิดข้อผิดพลาด',
                placement: 'top',
            });
        }

    }

    // เลือกจังหวัด
    const onChangeProvince = (val) => {
        console.log("val", val);
        setFilterProvince(val);
        setFilterDistrict(null); // รีเซ็ตอำเภอ
        filterDataProvince(val); // เรียก filter แบบ live
    };

    // เลือกอำเภอ
    const onChangeDistrict = (val) => {
        setFilterDistrict(val);
        filterDataDistrict(val); // เรียก filter แบบ live
    };
    // ฟิลเตอร์เลือกจังหวัด
    const filterDataProvince = (data) => {
        let filtered = dataAllProvince; // dataAllProvince คือ JSON ที่คุณเอามา

        // filter ตามจังหวัด
        if (data && data !== "all") {
            filtered = filtered.filter(item => item.provinceName === data);
        }
        // console.log("filtered", filtered);
        setSearchData(filtered);

    };
    // ฟิลเตอร์เลือกอำเภอ
    const filterDataDistrict = (data) => {
        let filtered = dataAllProvince; // dataAllProvince คือ JSON ที่คุณเอามา

        // filter ตามอำเภอ
        if (data && data !== "all") {
            filtered = filtered.filter(item => item.districtName === data);
        }
        // console.log("filtered", filtered);
        setSearchData(filtered);

    };

    const getDistrictOptions = () => {
        if (!filterProvince) return [];
        const districts = dataAllProvince
            .filter(item => item.provinceName === filterProvince)
            .map(item => item.districtName);
        return [...new Set(districts)];
    };

    const columns = [
        {
            title: 'เลขที่สัญญา',
            dataIndex: 'contno',
            key: 'contno',
            responsive: ["xs", "sm", "md", "lg"], // โชว์ทุกขนาดจอ
            ellipsis: true, // ถ้าข้อความยาว จะมี ...
        },
        {
            title: 'ลูกค้า',
            dataIndex: 'customerList',
            key: 'customerList',
            responsive: ["sm", "md", "lg"], // ซ่อนบนมือถือจอเล็กสุด (xs)
            render: (value) => {
                // console.log("value+++++++++++", value);

                return (
                    <>
                        {value?.map((cust, idx) => (
                            <div key={idx}>
                                {cust.snam} {cust.name1} {cust.name2}
                            </div>
                        ))}
                    </>
                );
            }
        },
        {
            title: 'ทรัพย์',
            dataIndex: 'customerList',
            key: 'customerList',
            responsive: ["sm", "md", "lg"], // ไม่แสดงใน xs
            render: (value) => {
                return (
                    <>
                        {value?.map((cust, idx) => (
                            <div key={idx}>
                                <span
                                    style={{
                                        color: cust?.investigation ? 'green' : 'red',
                                        fontWeight: 500,
                                    }}
                                >
                                    {cust?.investigation === true ? 'มีทรัพย์'
                                        : cust?.investigation === false ? 'ไม่มีทรัพย์'
                                            : cust?.investigation === null && 'ยังไม่เพิ่มทรัพย์'}
                                </span>
                            </div>
                        ))}
                    </>
                )
            }
        },
        {
            title: "Action",
            key: "action",
            fixed: "right",
            width: 80,
            render: (data) => {
                // console.log("data ตารางหลัก", data);

                return (
                    <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            openModal(data,);
                        }}
                    >
                        +
                    </Button>
                )
            }
        },
    ]

    return (
        <div style={{ maxWidth: "100%", margin: "auto", padding: 24 }}>
            <Divider style={{ margin: 2 }}> <h2>การเพิ่มทรัพย์</h2> </Divider>
            {loading ? <>
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Spin size="large" tip="กำลังโหลด..." />
                </div>
            </> :
                <>
                    <Row
                        gutter={[16, 16]}
                        justify="center"
                        style={{ marginBottom: 24 }}
                    >
                        <Col xs={24} sm={8} md={6}>
                            <Select
                                showSearch
                                value={filterProvince}
                                onChange={onChangeProvince}
                                style={{ width: "100%", height: 40 }}
                                placeholder="เลือกจังหวัด"
                            >
                                <Option value="all">ทั้งหมด</Option>
                                {optionProvince.map(prov => (
                                    <Option key={prov} value={prov}>{prov}</Option>
                                ))}
                            </Select>
                        </Col>

                        <Col xs={24} sm={8} md={6}>
                            <Select
                                showSearch
                                value={filterDistrict}
                                onChange={onChangeDistrict}
                                style={{ width: "100%", height: 40 }}
                                placeholder="เลือกอำเภอ"
                                disabled={!filterProvince || filterProvince === "all"}
                                allowClear
                            >
                                {getDistrictOptions().map(d => (
                                    <Option key={d} value={d}>{d}</Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ height: "100%", padding: "24px", paddingTop: 0 }}>
                        <Col span={24}>
                            <Row justify={'center'}>
                                {paginatedContracts && (
                                    <Collapse
                                        style={{ width: '100%' }}
                                        accordion
                                        expandIconPosition="start" // เอา icon มาวางซ้าย
                                        expandIcon={({ isActive }) => (
                                            <CaretRightOutlined
                                                style={{
                                                    fontSize: '24px',
                                                    color: '#5e6317',
                                                    transition: 'transform 0.2s',
                                                    transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)',
                                                    lineHeight: '60px', // ให้สูงเท่ากับ header
                                                }}
                                            />
                                        )}
                                    >
                                        {paginatedContracts?.map((item) => {
                                            return (
                                                <Panel
                                                    key={item.contno}
                                                    header={
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            flexWrap: "wrap",        // ให้แตกบรรทัดได้บนจอเล็ก
                                                            width: "100%",           // กว้างเต็มพื้นที่ panel
                                                            gap: "12px",             // ระยะห่างระหว่างแต่ละ div
                                                            fontSize: '16px',
                                                            fontWeight: '500',
                                                        }}>
                                                            <div style={{ marginRight: '30px' }}>รอบที่: {item.round} ({item?.provinceName})</div>
                                                            <div>วันลงพื้นที่: {dayjs(item.dateRound).format('DD-MM-YYYY')}</div>
                                                            <div></div>
                                                        </div>
                                                    }
                                                >
                                                    <Collapse
                                                        accordion
                                                        expandIconPosition="start"
                                                        expandIcon={({ isActive }) => (
                                                            <CaretRightOutlined
                                                                style={{
                                                                    fontSize: '24px',
                                                                    color: '#5e6317',
                                                                    transition: 'transform 0.2s',
                                                                    transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)',
                                                                    lineHeight: '60px',
                                                                }}
                                                            />
                                                        )}
                                                    >
                                                        <Panel
                                                            key={item.districtName}
                                                            header={
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'space-between',
                                                                        width: '100vh',
                                                                        fontSize: '16px',
                                                                        fontWeight: '500',
                                                                    }}
                                                                >
                                                                    <div style={{ marginRight: '30px' }}>อำเภอ: {item.districtName}</div>
                                                                </div>
                                                            }
                                                        >

                                                            {/* ตารางแสดงหลายสัญญา */}
                                                            <Table
                                                                dataSource={item.list}
                                                                rowKey="contno"
                                                                columns={columns}
                                                                size="small"
                                                                pagination={{
                                                                    pageSize: 5,
                                                                    responsive: true,
                                                                }}
                                                                scroll={{ x: "max-content" }} // ให้เลื่อนแนวนอนได้ถ้าคอลัมน์เยอะ
                                                                style={{ width: "100%" }}     // ให้เต็มจอมือถือ
                                                            />
                                                        </Panel>
                                                    </Collapse>
                                                </Panel>
                                            )
                                        })}
                                    </Collapse>
                                )}
                            </Row>
                            <Row justify="end">
                                <Pagination
                                    style={{ marginTop: 16 }}
                                    current={page}
                                    pageSize={pageSize}
                                    total={mockContracts.length}
                                    onChange={(p) => setPage(p)}
                                />
                            </Row>
                        </Col>
                    </Row>
                </>
            }
            {
                modalVisible ? (
                    <ModalsAddAssets
                        open={modalVisible}
                        onClose={setModalVisible}
                        guarantors={guarantors}
                        datas={datas}
                    />
                ) : null
            }
        </div>
    );
}

// export default MainInvestigatingAssets;
const MainInvestigatingAssetses = MotionHoc(MainInvestigatingAssets);
export default MainInvestigatingAssetses;
